import React, { useId } from "react";

interface AnimatedCheckboxProps {
  checked: boolean;
  onChange: () => void;
  className?: string;
  title?: string;
  "aria-label"?: string;
}

const AnimatedCheckbox: React.FC<AnimatedCheckboxProps> = ({
  checked,
  onChange,
  className,
  title,
  ...rest
}) => {
  const id = useId();

  return (
    <div className={className}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="peer sr-only"
        {...rest}
      />
      <label
        htmlFor={id}
        title={title}
        className="relative inline-flex items-center cursor-pointer select-none"
      >
        <span
          className="relative w-[18px] h-[18px] rounded-[3px] border border-[#9098a9] transition-all duration-200 ease-linear flex items-center justify-center overflow-hidden
                     peer-hover:border-[#506eec]
                     peer-checked:bg-[#506eec] peer-checked:border-[#506eec]"
        >
          {/* Ripple */}
          <span
            className="absolute inset-0 rounded-full bg-[#506eec] scale-0 opacity-100 peer-checked:scale-[3.5] peer-checked:opacity-0 transition-all duration-500 ease-out"
            aria-hidden
          />
          {/* Checkmark */}
          <svg
            viewBox="0 0 12 10"
            width="12"
            height="10"
            className="relative z-10 text-[#3B82F6] dark:text-white"
          >
            <polyline
              points="1.5 6 4.5 9 10.5 1"
              fill="none"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="stroke-current"
              style={{ strokeDasharray: 16, strokeDashoffset: checked ? 0 : 16, transition: "stroke-dashoffset 300ms ease 100ms" }}
            />
          </svg>
        </span>
      </label>
    </div>
  );
};

export default AnimatedCheckbox;
